import { Component, DestroyRef, inject, viewChild } from "@angular/core"
import { RouterOutlet } from "@angular/router"

import { ConfirmDialogModule } from "primeng/confirmdialog"
import { Toast } from "primeng/toast"

import { LgkProgressSpinner } from "@logick/ui/progress-spinner"

import { MaintenanceDialog } from "@/core/maintenance"

@Component({
  selector: "app-root",
  imports: [RouterOutlet, Toast, ConfirmDialogModule, LgkProgressSpinner, MaintenanceDialog],
  template: `
    <p-toast position="top-center" [preventOpenDuplicates]="true" [preventDuplicates]="false" />
    <p-confirmdialog/>
    <lgk-progress-spinner #loader message="Veuillez patienter..." [visible]="false" />
    <app-maintenance-dialog />
    <router-outlet />`,
})
export class AppComponent {

  constructor() {}

}
